import { zfd } from 'zod-form-data';
import { ClaimType } from '~/utils/constants';
import { makeCrewAction, redirect } from '~/utils/routing';
import { shipmentMethodSchema } from '~/utils/schemas';

export const FIELD_KEY = 'return-method';

const formDataSchema = zfd.formData({
  [FIELD_KEY]: zfd.json(shipmentMethodSchema),
});

export const { action, useActionResult } = makeCrewAction(
  ({ formData, context }, appState) => {
    const result = formDataSchema.safeParse(formData);

    if (!result.success) {
      return {
        ok: false,
        message: 'Invalid value for return method',
      };
    }

    const method = result.data[FIELD_KEY];

    appState.dispatch(appState.actions.crewClaim.setReturnMethod(method));

    const reviewPage =
      context.claimType === ClaimType.warranty ?
        `../review/warranty`
      : `../review/return`;

    return redirect(reviewPage);
  },
);
